import { getCsiTrigger } from 'app/providers/csi/lib/getCsiTrigger';
import { CsiCapableResponse, CsiMode, CsiTrigger } from 'app/providers/csi/model/types';
import { useCsiContext } from 'app/providers/csi/provider';

/**
 * Single entry point for feedback CSI (CsiProvider).
 * Independent of the signing method (ASAN, OTP, direct API): pass the response, the module handles the rest.
 */
export const useCsi = () => {
  const { openModal, openFeedbackDirect } = useCsiContext();

  const open = (trigger: CsiTrigger, mode: CsiMode = 'confirm') => {
    if (mode === 'direct') {
      openFeedbackDirect(trigger.endpoint, trigger.businessKey, trigger.redirectUrl);

      return;
    }
    openModal(trigger.endpoint, trigger.businessKey, trigger.redirectUrl, trigger.dialogLabel);
  };

  /** Opens CSI if the response contains csi. Returns true if it was opened. */
  const handleResponse = (response?: CsiCapableResponse | null, mode: CsiMode = 'confirm') => {
    const trigger = getCsiTrigger(response);
    if (trigger) open(trigger, mode);

    return trigger !== null;
  };

  return { open, handleResponse };
};
